// extracted by mini-css-extract-plugin
module.exports = {"burgerNav":"Navbar_burgerNav__3QhdA"};